<div class="logindiv">
  <form *ngIf="!isLoggedIn" name="form" class="login-form" #f="ngForm" novalidate>
    <h2 class="login-header">Log in</h2>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput 
             placeholder="Your email" 
             [(ngModel)]="form.email" 
             name="email" 
             required 
             #email="ngModel" 
             autocomplete="email">
      <mat-error *ngIf="email.invalid && (email.dirty || email.touched)">
        <span *ngIf="email.errors?.['required']">Email is required.</span>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input matInput 
             [type]="hide ? 'password' : 'text'" 
             placeholder="Password" 
             [(ngModel)]="form.password" 
             name="password" 
             required 
             #password="ngModel" 
             autocomplete="current-password">
      <mat-icon matSuffix (click)="hide = !hide" class="pointer-icon">
        {{hide ? 'visibility_off' : 'visibility'}}
      </mat-icon>
      <mat-hint *ngIf="!password.value">Enter your password</mat-hint>
      <mat-error *ngIf="password.invalid && (password.dirty || password.touched)">
        <span *ngIf="password.errors?.['required']">Password is required.</span>
      </mat-error>
    </mat-form-field>

    <div class="link-row">
      <a class="fakelink" (click)="elapseReset()">forgot password</a>
    </div>

    <div *ngIf="!showSpinner && isLoginFailed" class="alert-error" role="alert">
      {{ errorMessage }}
    </div>

    <div class="action-row">
      <mat-progress-spinner *ngIf="showSpinner" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
      <button mat-raised-button 
              color="primary" 
              (click)="login()" 
              [disabled]="showSpinner || f.invalid">
        Log in
      </button>
    </div>

    <div *ngIf="reset" class="reset-container">
      <mat-divider class="reset-divider"></mat-divider>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email for password reset</mat-label>
        <input matInput placeholder="Your email address" [(ngModel)]="form.email" name="resetEmail" required>
      </mat-form-field>
      <div class="action-row">
        <button mat-stroked-button color="primary" (click)="resetPassword()">Reset Password</button>
      </div>
    </div>

  </form>
</div>